import * as React from 'react';
import { FC, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Avatar } from 'ui/avatar/Avatar';
import { UserMenu } from 'moduleBase/types/Menu';
import { useUserData } from 'components/user/hooks/use-user-data';
import { ProfileInfoContent } from '../components/ProfileInfoContent/ProfileInfoContent';

type PropsType = {
  userMenu: UserMenu,
};

const Profile: FC<PropsType> = ({ userMenu }) => {
  const userData = useUserData();
  const [isOpen, setIsOpen] = useState(false);

  const hide = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const show = () => {
    setIsOpen(true);
  };

  // noinspection HtmlUnknownTarget
  return (
    <div className="col-auto d-none d-xl-block">
      <Dropdown
        className="profile-dropdown"
        show={isOpen}
        onToggle={(isOpenLocal, event, metadata) => {
          if (metadata.source === 'rootClose') {
            hide();
          } else {
            show();
          }
        }}
      >
        <Dropdown.Toggle variant="link" id="dropdown-profile-button" className="p-0 rounded-circle border-0 h-auto">
          <Avatar image={userData.avatar.image} />
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdown-flat-menu dropdown-flat-menu_fixed-size dropdown-menu-right"

        >
          <ProfileInfoContent hide={hide} userMenu={userMenu} />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export { Profile };
